export const UnleashProxyConfig = {
    url: process.env.VUE_APP_UNLEASH_PROXY_URL,
    clientKey: process.env.VUE_APP_UNLEASH_CLIENT_KEY,
    refreshInterval: 60,
    appName: 'Lyra'
};
